import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  Button,
  Box,
  IconButton,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Formik } from "formik";
import CloseIcon from "@material-ui/icons/CloseRounded";
import Grid2 from "@mui/material/Unstable_Grid2";

const useStyles = makeStyles((theme) => ({
  accessBox: {
    display: "flex",
    flexFlow: "column",
  },
  publishButton: {
    color: theme.palette.common.white,
  },
  scrollContainer: {
    maxHeight: "70vh",
    overflowY: "auto",
    backgroundColor: "#f3f3f3",
  },
  dialogPaper: {
    maxWidth: '800px',
  },
}));

export default function EditAdminDialogComponent({
  open,
  handleSubmit,
  handleClose,
  selected
}) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll="paper"
      classes={{ paper: classes.dialogPaper }}
      fullWidth
    >
      <Formik
        initialValues={{
          email: selected?.email,
          username: selected?.username,
        }}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <form onSubmit={formik.handleSubmit}>
            <DialogTitle id="scroll-dialog-title">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box flexGrow={1}>
                    <Typography fontSize={16}>
                      Edit Admin
                    </Typography>
                  </Box>
                </Box>

                <IconButton
                  size="small"
                  color="inherit"
                  onClick={handleClose}
                  style={{ padding: 0 }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent style={{ backgroundColor: 'white' }} dividers className={classes.scrollContainer}>
              <Box className={classes.accessBox} mt={2} display="flex" flexDirection="column" style={{ columnGap: 2 }}>
                <Grid2 container rowSpacing={2}>
                  <Grid2 xs={4} display="flex" alignItems="center">
                    <Typography fontSize={16}>
                      Email
                    </Typography>
                  </Grid2>
                  <Grid2 xs={8}>
                    <TextField
                      fullWidth
                      label="Email"
                      name="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      variant="outlined"
                    />
                  </Grid2>
                  <Grid2 xs={4} display="flex" alignItems="center">
                    <Typography fontSize={16}>
                      Username
                    </Typography>
                  </Grid2>
                  <Grid2 xs={8}>
                    <TextField
                      fullWidth
                      label="Username"
                      name="username"
                      value={formik.values.username}
                      onChange={formik.handleChange}
                      variant="outlined"
                    />
                  </Grid2>
                </Grid2>
                <Box mt={2} />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                variant="text"
                type="button"
                onClick={handleClose}
                style={{ color: "black" }}
              >
                Cancel
              </Button>
              <Button variant="contained" type="submit">
                Save
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
}
